import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import logo2 from "assets/images/icons/Logo2.svg";
import logo3 from "assets/images/icons/Logo3.svg";

interface LogoHeaderProps {
  imageSize?: string;
  screen?: string;
}

const LogoHeader: React.FC<LogoHeaderProps> = ({
  imageSize = "155px",
  screen = "",
}) => {
  return (
    <Grid
      container
      sx={{
        height: "max-content",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        padding: "0rem 1.4rem",
      }}
    >
      {[logo2].map((logo, index) => (
        <Box
          key={index}
          component="img"
          src={logo}
          alt={`Logo ${index + 1}`}
          sx={{
            width:
              screen === "login" && index === 0 ? "185px" : index === 0 ? "190px" : imageSize,
            height: "auto",
            maxWidth: "100%",
          }}
        />
      ))}
    </Grid>
  );
};

export default LogoHeader;
